import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store ({
  state:{
    name:localStorage.getItem('name')|| ''
  },
  actions:{
    aass(ctx,items){
      ctx.commit('ssa',items)
    }
  },
  mutations:{
     ssa(state,items){
       state.name = items
     }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js